import { render, staticRenderFns } from "./About.vue?vue&type=template&id=8ce9b6be&scoped=true"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=8ce9b6be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce9b6be",
  null
  
)

export default component.exports